import { File } from "@ludens-reklame/rubics-v3-sdk/file/types";
import { ButtonAction, ButtonActionProps } from "../../internal-components/Button.js";
import { RichText } from "../../internal-components/RichText.js";
import { Constrainer } from "../../internal-components/Layout.js";
import type { BackgroundColor } from "../../types/theme.js";
import {
  Layout,
  Title,
  Background,
  Content,
  Buttons,
  HorizontalSpacer,
  VideoWrapper,
  VideoContent,
} from "./styles.js";

interface HeroVideoProps {
  title?: string;
  titleSize?: number;
  text?: string;
  actions?: ButtonActionProps[];
  video: File;
  backgroundColor?: BackgroundColor;
}

export const HeroVideo: React.FC<HeroVideoProps> = ({
  title,
  titleSize,
  text,
  actions = [],
  video,
  backgroundColor = "surface1",
}) => {
  return (
    <Constrainer>
      <Background $bg={backgroundColor}>
      <VideoWrapper $hasContent={!!(title || text || actions.length > 0)}>
        <video autoPlay muted loop playsInline>
          <source src={video.url} />
        </video>
        <VideoContent>
          <HorizontalSpacer>
            <Constrainer>
              <Layout $hasImage={true} $hasSlides={false}>
                <Content $hasImage={true} $hasSlides={false}>
                  {title && <Title $size={titleSize}>{title}</Title>}
                  {text && (
                    <RichText
                      className="rich-text b2"
                      dangerouslySetInnerHTML={{ __html: text }}
                    />
                  )}
                  {actions.length > 0 && (
                    <Buttons className="hero--actions" $hasImage={true}>
                      {actions.map((action, i) => (
                        <ButtonAction key={i} {...action} />
                      ))}
                    </Buttons>
                  )}
                </Content>
              </Layout>
            </Constrainer>
          </HorizontalSpacer>
        </VideoContent>
      </VideoWrapper>
      </Background>
    </Constrainer>
  );
};
